import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { DebounceInput } from 'react-debounce-input';

import Utils from '../../../Services/Utils';

import InputWrapper from '../WrapperInput';
import withShallowComparison from '../../Common/withShallowComparisonUpdate';
import $ from "../../../../offline/jquery.min";

class InputTextArea extends React.PureComponent {

  constructor(props) {
    super(props);
    this.textArea = React.createRef();
  }

  componentDidMount() {
    this.initValidate();
  }

  componentDidUpdate() {
    this.initValidate();
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  }

  validate = (value) => {
    const { required, validators, maxlength, minlength, patterntext, patterntexterror } = this.props;
    if (required && Utils.isNull(value)) return 'This field is required.';
    if (maxlength && (!Utils.isNull(value) && (value.length > parseInt(maxlength)))) {
      return 'This field must have a maximum of ' + maxlength + ' characters';
    }
    if (minlength && (!Utils.isNull(value) && (value.length < parseInt(minlength)))) {
      return 'This field must have a minimum of ' + minlength + ' characters';
    }
    if (patterntext && (!Utils.isNull(value) && (!patterntext.test(value)))) return patterntexterror;
    for (const validator of validators || []) {
      if (validator(value)) return validator(value);
    }
    return '';
  };

  handleChange = (e) => {
    const { onChange, onError, error } = this.props;
    const value = e && e.target ? e.target.value : e;
    if (onChange) onChange(value);
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  };

  handleKeyDown = (e) => {
    const { onSubmit, maxlength } = this.props;
    if (e.keyCode !== 8) {
      if (e.keyCode === 13 && e.shiftKey) {
        // Allow default behavior (new line)
        return;
      }
      else if (e.keyCode === 13) {
        if (onSubmit) onSubmit();
        e.preventDefault();
      }
      else {
        if ($(this.textArea.current).val().toString().length === parseInt(maxlength)) {
          if (e.keyCode !== 9) {
            e.preventDefault();
          }
        }
      }
    }
  };

  render() {
    const {
      className,
      label,
      labelhtml,
      error,
      placeholder,
      disabled,
      required,
      value,
      debounce,
      disablechange,
      onChange,
      onBlur,
      onClick,
      onFocus,
      onKeyDown,
      readOnly
    } = this.props;

    const WrapperProps = {
      className,
      label,
      labelhtml,
      error,
      required,
    };

    const debounceTimeout = !Utils.isNull(debounce) ? debounce : 500;
    const changeProps = {
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      onClick: onClick,
      onKeyDown: onKeyDown,
    };
    if (!disablechange) {
      changeProps['onChange'] = this.handleChange;
    }

    return (
      <InputWrapper { ...WrapperProps }>
        <DebounceInput
          inputRef={ this.textArea }
          rows='6'
          element="textarea"
          value={ !Utils.isNull(value) ? value : '' }
          disabled={ disabled }
          required={ required }
          readOnly={ readOnly }
          {...changeProps}
          onKeyDown={ this.handleKeyDown }
          debounceTimeout={ debounceTimeout }
          className={ classNames('InputText', {
            InputText_Disabled: Boolean(disabled),
          }) }
          placeholder={ placeholder }
        />
      </InputWrapper>
    );
  }
}

InputTextArea.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  error: PropTypes.string,
  minlength: PropTypes.string,
  maxlength: PropTypes.string,
  validators: PropTypes.array,
  placeholder: PropTypes.string,
  patterntext: PropTypes.string,
  patterntexterror: PropTypes.string,
  debounce: PropTypes.number,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onError: PropTypes.func,
  disablechange: PropTypes.string
};

export default withShallowComparison(InputTextArea, ['onChange', 'onError']);